<template>
  <div class="main">
    <topImg
      title="以客户为中心"
      img="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/banners/banner_kehuzhongxin.png"
    ></topImg>
    <!-- 介绍 -->
    <div class="introduce">
      <img
        src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/chanpin_kehu/kehu/introduce.png"
        alt=""
      />
      <div class="right">
        <div class="title">客户服务介绍</div>
        <div class="desc">
          以客户为中心，格如灵建立多维度的客户跟踪和服务机制，以实际行动践行服务初心，赢得客户高度认可。
          聚焦教师和学生能力提升，为师生提供涵盖操作与理念的培训课程，提高XR设备操作技能和信息化教学理念，保障每一款产品都能成为客户高效教学的助手，是格如灵客户服务团队践行的使命。
        </div>
      </div>
    </div>
    <!-- 售前服务 -->
    <div class="beforeService">
      <div>
        <div class="headline">售前服务体系</div>
        <div class="content">
          <div class="left">
            <div class="list">
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6254ea4fa918e/867613236.png"
                alt=""
              />
              <span class="title">快速响应对接</span>
            </div>
            <div class="list">
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6254ea4b54fd8/700503897.png"
                alt=""
              />
              <span class="title">售前一对一服务</span>
            </div>
            <div class="list">
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6254ea50220c6/434265618.png"
                alt=""
              />
              <span class="title">行业专家定制方案</span>
            </div>
            <div class="list">
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6254ea51d3a38/375958287.png"
                alt=""
              />
              <span class="title">现场产品演示</span>
            </div>
            <div class="list">
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6254ea4d654e1/744592943.png"
                alt=""
              />
              <span class="title">属地化服务支撑</span>
            </div>
            <div class="list">
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6254ea520c9ce/349220593.png"
                alt=""
              />
              <span class="title">专业团队服务流程</span>
            </div>
          </div>
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6254f26deea15/294836661.png"
            alt=""
            class="right"
          />
        </div>
      </div>
    </div>
    <!-- 售后服务 -->
    <div class="afterService">
      <div class="headline">售后服务体系</div>
      <div class="content">
        <div class="left">
          <div class="list">落地培训支持</div>
          <div class="list">全程技术支持</div>
          <div class="list">专业教研团队支持</div>
          <div class="list">售后一对一服务</div>
          <div class="list">VR教学公开课</div>
        </div>
        <div class="middle">
          <img
            src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/chanpin_kehu/kehu/shouhou.png"
            alt=""
          />
        </div>
        <div class="right">
          <div class="list">专业教学培训</div>
          <div class="list">定期教学研讨会</div>
          <div class="list">功能/课件更新升级</div>
          <div class="list">定期客户回访</div>
        </div>
      </div>
    </div>
    <!-- 一站式服务 -->
    <div class="oneStop">
      <div>
        <div class="headline">客户服务范围</div>
        <div class="type">
          <div class="list">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6254ea4b31214/363941973.png"
              alt=""
            />
            <span class="title">全程技术支持</span>
            <span class="desc"
              >提供全程技术支持，业务受理后全程跟踪服务 客户服务团队一对一在线提供售前咨询、售后支持服务
            </span>
          </div>
          <div class="list">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6254ea4b54fd8/700503897.png"
              alt=""
            />
            <span class="title">全流程服务</span>
            <span class="desc"
              >各行业的专家根据属性、规模、区域等定制个性化方案
              从售前到售后各阶段，提供闭环式全流程的支撑服务
            </span>
          </div>
          <div class="list">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6254ea4d654e1/744592943.png"
              alt=""
            />
            <span class="title">属地化支撑</span>
            <span class="desc"
              >强大的属地化支撑能力，在全国22个省级地区落地服务，20年以上教学经验的教研团队进行教学与培训</span
            >
          </div>
        </div>
        <img
          src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_625f812dd8672/144564469.png"
          alt=""
        />
        <span class="site"
          >在北京、上海、南昌、杭州、成都、武汉、青岛、深圳下设 8 个子公司</span
        >
        <span></span>
      </div>
    </div>
    <!-- 案例 -->
    <div class="case">
      <div class="headline">相关案例</div>
      <div class="desc">从售前到售后各阶段，提供闭环式全流程支撑</div>
      <div class="content">
        <div class="list" v-for="item of list" :key="item.id">
          <img
            :src="item.thumb"
            alt=""
          />
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
      <div class="more" @click="go('customerStories')">
        <span>查看更多案例</span>
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/60.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { caseList } from '@/services/api';

export default {
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      caseList({
        catid: 21
      }).then(res => {
        this.list.push(res.data.list[0]);
      });
      caseList({
        catid: 22
      }).then(res => {
        this.list.push(res.data.list[0]);
        this.list.push(res.data.list[1]);
      });
    },
    go(name) {
      this.$router.push({
        name
      });
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  .introduce {
    width: 1200px;
    height: 584px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > img {
      width: 514px;
      height: 393px;
      align-self: start;
      margin-top: 95px;
    }
    > .right {
      width: 668px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #000000;
        line-height: 45px;
      }
      .desc {
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
        margin-top: 22px;
      }
    }
  }
  .beforeService {
    padding-top: 62px;
    width: 100%;
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/kehu_shouqian.png);
    background-size: 100% 100%;
    > div {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      .headline {
        font-size: 28px;
        font-weight: 600;
        color: #000000;
        line-height: 40px;
        text-align: center;
      }
      .content {
        padding-top: 44px;
        display: flex;
        justify-content: space-between;
        .left {
          width: 700px;
          padding-top: 112px;
          .list {
            float: left;
            width: 200px;
            img {
              width: 45px;
              margin: 0 auto;
              margin-bottom: 22px;
              display: block;
            }
            .title {
              font-size: 16px;
              font-weight: 500;
              color: #000000;
              line-height: 22px;
              padding-bottom: 60px;
              text-align: center;
              display: block;
            }
          }
        }
        .right {
          width: 499px;
          height: 513px;
        }
      }
    }
  }
  .afterService {
    padding-top: 62px;
    padding-bottom: 137px;
    width: 100%;
    .headline {
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      text-align: center;
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      padding-top: 69px;
      display: flex;
      justify-content: space-between;
      .left,
      .right {
        height: 533px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        .list {
          width: 243px;
          height: 90px;
          background: #f7fafc;
          border-radius: 2px;
          text-align: center;
          line-height: 90px;
          font-size: 16px;
          font-weight: 400;
          color: #000000;
        }
      }
      .middle {
        width: 620px;
        margin-top: 43px;
        img{
          width: 100%;
        }
      }
    }
  }
  .oneStop {
    padding-top: 62px;
    width: 100%;
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/kehu_fanwei.png);
    background-size: 100% 100%;
    padding-bottom: 89px;
    > div {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      .headline {
        font-size: 28px;
        font-weight: 600;
        color: #000000;
        line-height: 40px;
        text-align: center;
      }
      .type {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 74px;
        .list {
          width: 336px;
          img {
            width: 45px;
            margin: 0 auto;
            display: block;
          }
          .title {
            display: block;
            text-align: center;
            font-size: 16px;
            font-weight: 500;
            color: #000000;
            line-height: 22px;
            padding-top: 22px;
          }
          .desc {
            display: block;
            text-align: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
            padding-top: 12px;
          }
        }
      }
      > img {
        width: 1034px;
        display: block;
        margin: 0 auto;
        margin-top: 75px;
      }
      .site {
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #7b8596;
        line-height: 25px;
        padding-top: 53px;
        display: block;
      }
    }
  }
  .case {
    width: 1200px;
    margin: 0 auto;
    padding-top: 54px;
    .headline {
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      text-align: center;
    }
    > .desc {
      font-size: 14px;
      font-weight: 400;
      color: #707483;
      line-height: 20px;
      text-align: center;
      margin-top: 12px;
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 54px;
      .list {
        width: 380px;
        height: 420px;
        background: #ffffff;
        box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.12);
        border-radius: 19px;
        overflow: hidden;
        img {
          width: 100%;
          height: 324px;
          display: block;
          object-fit: cover;
        }
        .title {
          width: 100%;
          height: 96px;
          text-align: center;
          font-size: 22px;
          font-weight: 400;
          color: #000000;
          line-height: 96px;
        }
      }
    }
    .more {
      padding: 62px 0;
      display: flex;
      justify-content: center;
      cursor: pointer;
      span {
        font-size: 14px;
        font-weight: 500;
        color: #444a62;
        line-height: 17px;
      }
      img {
        width: 14px;
        height: 12px;
        margin-left: 6px;
        margin-top: 2px;
      }
    }
  }
}
</style>
